// .u_full-slider

(function ($) {
  var $slider = $('.u_full-slider')
  $slider.each(function (i, thisSlider) {
    sliderInit($(thisSlider))
  })
  var $galleries = $('.u_full-slider__galleries')
  galleryItemInit($galleries)

  function sliderInit (thisSlider) {
    $(thisSlider).slick({
      dots: false,
      autoplay: true,
      autoplaySpeed: 6000
    })
  }
  function galleryItemInit ($galleries) {
    $galleries.on('click', '.u_full-slider--slide', function () {
      openGallery($(this))
    })
  }
})(window.jQuery)
